export default "__VITE_ASSET__mw3u5jRJ__"